import { render, staticRenderFns } from "./onePager-header.vue?vue&type=template&id=050005fc&scoped=true"
import script from "./onePager-header.vue?vue&type=script&lang=js"
export * from "./onePager-header.vue?vue&type=script&lang=js"
import style0 from "./onePager-header.vue?vue&type=style&index=0&id=050005fc&prod&lang=css"
import style1 from "./onePager-header.vue?vue&type=style&index=1&id=050005fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050005fc",
  null
  
)

export default component.exports